module.exports = __webpack_public_path__ + "img/logo-vcard.45852ad.png";